import { useQuery } from "@tanstack/react-query"
import { gmailIntegrationsQuery } from "modules/settings/lib/gmail/gmailIntegrationsQuery"

export function useGmailIntegrationsQuery(...args: Parameters<typeof gmailIntegrationsQuery>) {
  return useQuery(gmailIntegrationsQuery(...args))
}
